// @flow
import ConfirmDeleteWorklogModal from './ConfirmDeleteWorklogModal';

export default ConfirmDeleteWorklogModal;
